/* eslint-disable no-extra-parens */
import {
    CogIcon,
    HeroCalendarDaysIcon,
    HeroEllipsisVerticalIcon,
    HeroShieldExclamationIcon,
} from 'components/Icon'

import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper, list,
} from './../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'

import React from 'react'
import Tooltip from 'components/Tooltip'


import {navigation} from 'navigation'
import {styled} from 'stitches/config'

import {
    useAppSelector,
} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)

export const SideMenuChannelSettingsView = (): React.ReactElement => {
    const {t} = useTranslation()

    const {channel_id} = useAppSelector(({navigation: navigationState}) => navigation.route.params<'ChannelSettings'>(navigationState.routes[navigationState.position]))

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button
                                color='text'
                                iconLeft={CogIcon}
                                onPress={(): void => { navigation.push('ChannelSettings', {channel_id}) }}
                                text={t('General settings')}
                            />
                            <Button
                                color='text'
                                iconLeft={HeroShieldExclamationIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('ChannelSettings', {
                                        channel_id,
                                        tab: 'privacy',
                                    })
                                }}
                                text={t('Privacy')}
                            />
                            <Button
                                color='text'
                                iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                                onPress={(): void => {
                                    navigation.push('ChannelSettings', {
                                        channel_id,
                                        tab: 'schedule',
                                    })
                                }}
                                text={t('Schedule')}
                            />
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='general'
                    iconLeft={CogIcon}
                    onPress={(): void => { navigation.push('ChannelSettings', {channel_id}) }}
                    text=''
                />
                <Tooltip id='general' position='right' singleLine>
                    {t('General settings')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='privacy'
                    iconLeft={HeroShieldExclamationIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('ChannelSettings', {
                            channel_id,
                            tab: 'privacy',
                        })
                    }}
                    text=''
                />
                <Tooltip id='privacy' position='right' singleLine>
                    {t('Privacy')}
                </Tooltip>
            </li>
            <li>
                <Button
                    color='text'
                    data-tooltip-id='schedule'
                    iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                    onPress={(): void => {
                        navigation.push('ChannelSettings', {
                            channel_id,
                            tab: 'schedule',
                        })
                    }}
                    text=''
                />
                <Tooltip id='schedule' position='right' singleLine>
                    {t('Schedule')}
                </Tooltip>
            </li>
        </StyledList>
    )
}
